<template>
  <div class="preview d-flex">
    <div
      class="preview__image-container d-flex align-center justify-center blue-grey lighten-5"
    >
      <ImageMedia
        v-if="image"
        zoomable
        :defaultImage="image"
        :src="image"
        :key="key"
      />
    </div>

    <div
      v-if="!readOnly"
      class="preview__actions d-flex flex-column align-center justify-start"
    >
      <Button
        class="mb-2"
        color="grey"
        icon="mdi-delete-outline"
        @click="$emit('delete')"
      />

      <Button color="grey" icon="mdi-pencil" @click="$emit('edit')" />
    </div>
  </div>
</template>

<script>
import uuid from 'uuid/v4'
import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'GalleryPreview',

  components: {
    ImageMedia,
    Button,
  },

  props: {
    image: [Object, String],

    readOnly: Boolean,
  },

  data() {
    return {
      key: uuid(),
    }
  },

  watch: {
    image() {
      this.key = uuid()
    },
  },
}
</script>

<style lang="scss" scoped>
.preview {
  min-height: 65vh;
  width: calc(100% - 230px); // 230px for the thumbnails container

  &__image-container {
    height: 100%;
    width: calc(
      100% - 64px
    ); // 64px for the actions (edit/delete) container. Only visible in edit mode.
    overflow: hidden;
  }

  &__actions {
    width: 64px;
  }
}
</style>
